export const UNSUPPORTED_BROWSER_ALERT = 'unsupported-browser-alert';
